// Types for cascade delete functionality - shared by connections and partners API services

/**
 * Represents a dependent resource that would be affected by cascade delete
 */
export interface CascadeDeleteDependency {
  type: 'task' | 'connection';
  id: string;
  name: string;
}

/**
 * Result of a delete operation, including cascade delete summary
 */
export interface CascadeDeleteResult {
  success: boolean;
  message: string;
  cascadeDeleted?: {
    tasks?: number;
    connections?: number;
  };
}

/**
 * Error thrown when trying to delete a resource that has dependencies.
 * Contains the list of dependencies that must be deleted first.
 */
export class DependencyError extends Error {
  public dependencies: CascadeDeleteDependency[];
  public dependencyCount: number;
  public hint?: string;
  public status: number = 409;

  constructor(message: string, dependencies: CascadeDeleteDependency[], dependencyCount: number, hint?: string) {
    super(message);
    this.name = 'DependencyError';
    this.dependencies = dependencies;
    this.dependencyCount = dependencyCount;
    this.hint = hint;
  }
}
